import { LinearProgress } from "@mui/material"

export function ComponentTablePageLoading() {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 dark:border-blue-400 mx-auto" />
        <div className="space-y-2">
          <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">Loading data...</h3>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Please wait while we fetch your information
          </p>
        </div>
      </div>
    </div>
  )
}

export function ComponentTableInlineDataLoading() {
  return (
    <div className="w-full">
      <LinearProgress />
    </div>
  )
}
